































































































import { Component, Vue } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'

import PageContainer from '@/components/PageContainer.vue'
import BasketSection from '@/components/BasketSection.vue'
import { PaymentStateObjectMap, PaymentStateObject, SalesContactObjectMap } from '@/store/types'
import { ObservableStream } from '@/service/ObservableStream'
import { documentAddScript } from '@/service/DocumentExtScripts'
import config from '@/config'
import {
	PaymentState,
	PaymentStateMap,
	OrderSummaryReply,
	SalesContactTypeMap,
} from 'proto/eshop/Basket_pb'

@Component({
	components: {
		PageContainer,
		BasketSection,
	},
})
export default class LandingPage extends Vue {
	private readonly orderInfo = config.order
	private readonly basketLink = config.basketLink
	private readonly currency = config.currency
	private readonly vat = config.vat
	private readonly salesContacts = config.salesContacts
	private readonly negativeStates: Array<PaymentStateMap[keyof PaymentStateMap]> = [
		PaymentState.NO_ORDER_STATE,
		PaymentState.CANCELLED,
		PaymentState.DENIED,
		PaymentState.REFUND_REQUEST,
		PaymentState.REFUND_PROCESSING,
		PaymentState.RETURNED,
		PaymentState.REVERSED,
	]
	private stream!: ObservableStream<OrderSummaryReply>
	@State private readonly salesContactTypeMap!: SalesContactObjectMap
	@State private readonly paymentStateMap!: PaymentStateObjectMap
	@State private readonly paymentStateValue!: keyof PaymentStateObjectMap
	@Action private setState!: (state: keyof PaymentStateObjectMap) => void
	@Action private streamState!: (id: string) => Promise<ObservableStream<OrderSummaryReply>>
	get totalPrice100(): number {
		if (!this.orderInfo) return 0
		return this.orderInfo.total100
	}
	get totalPriceVAT(): number {
		if (!this.orderInfo) return 0
		return this.totalPrice100 / (1 + this.vat) * this.vat
	}
	get state(): PaymentStateObject {
		if (this.paymentStateValue !== null) {
			return this.paymentStateMap[this.paymentStateValue]
		}
		if (this.orderInfo) {
			const value = this.orderInfo.paymentstatus
			this.$nextTick(() => this.setState(value))
		}
		return this.paymentStateMap[0]
	}
	get title(): string {
		let message: string = this.$t('Thank you for visiting Navitel online store!')
		if (this.orderInfo) {
			const value = this.orderInfo.paymentstatus
			if (value && this.negativeStates.indexOf(value) < 0) {
				message = this.$t('Thank you for your purchase!')
			}
		}
		return message
	}
	async mounted() {
		if (this.orderInfo) {
			const id = this.orderInfo.id
			this.stream = await this.streamState(id)
			this.stream.listen((response) => {
				this.setState(response.getPaymentstatus())
			})
		}

		for (var js of config.landingScriptsList) {
			documentAddScript(js)
		}
	}
	private getContactLabel(type: ValueOf<SalesContactTypeMap>): string {
		return this.salesContactTypeMap[type].label
	}
	private getContactLink(type: ValueOf<SalesContactTypeMap>, value: string): string {
		const start = this.salesContactTypeMap[type].link
		return `${start}${value}`
	}
	beforeDestroy() {
		if (this.stream) this.stream.cancel()
	}
}
